<app-sidenav *ngIf="identity">
</app-sidenav>

<router-outlet *ngIf="!identity"></router-outlet>